import { IMultiLocationRoute } from "../types/IMultiLocationRoute";
import {
  IQuoteExtension,
  IQuoteExtensionOld,
  IQuotesByDestination,
  IQuotesByDestinationOld,
} from "../types/ICompAnalysisQMD";

export const convertQuotesToRoutesOld = (
  quotes: IQuotesByDestinationOld[],
): IMultiLocationRoute[] => {
  const routes: IMultiLocationRoute[] = [];

  quotes.forEach((item: IQuotesByDestinationOld) => {
    item.quotes?.forEach((quote: IQuoteExtensionOld) => {
      routes.push({
        origin: {
          id: quote.origin.id,
          coordinate: quote.origin.coordinate || [0, 0],
          name: quote.origin.name,
          owner: quote.origin.details?.owner,
          city: quote.origin.city || "",
        },
        destination: {
          id: item.destination.id,
          coordinate: item.destination.coordinate || [0, 0],
          city: item.destination.city || "",
          name: item.destination.name,
          pinType: item.destination.pinType || "city",
          owner: item.destination.details?.owner,
        },
        availableProducts: item.destination.availableProducts,
        freight: quote.freight?.totalFreight || 0,
        mode: quote.mode,
        maxPrice: quote.maxPrice || 0,
        occupantTypes: quote.competitor ? ["Competitor"] : ["Koch"],
        competitor: quote.competitor,
        legs: [
          {
            // minCars only exists on Rail freight, will be undefined for Truck
            minCars:
              quote.freight && "minCars" in quote.freight
                ? quote.freight.minCars
                : undefined,
          },
        ],
      });
    });
  });

  return routes;
};

export const convertQuotesToRoutes = (
  quotes: IQuotesByDestination[],
): IMultiLocationRoute[] => {
  const routes: IMultiLocationRoute[] = [];

  quotes.forEach((item: IQuotesByDestination) => {
    item.quotes?.forEach((quote: IQuoteExtension) => {
      routes.push({
        origin: {
          id: quote.origin.id,
          coordinate: quote.origin.coordinate || [0, 0],
          name: quote.origin.name,
          owner: quote.origin.details?.owner,
          city: quote.origin.city || "",
        },
        destination: {
          id: item.destination.id,
          coordinate: item.destination.coordinate || [0, 0],
          city: item.destination.city || "",
          name: item.destination.name,
          pinType: item.destination.pinType || "city",
          owner: item.destination.details?.owner,
        },
        availableProducts: item.destination.availableProducts,
        freight: quote.freight?.totalFreight || 0,
        mode: quote.mode,
        maxPrice: typeof quote.postedPrice === "number" ? quote.postedPrice : 0,
        occupantTypes: quote.competitor ? ["Competitor"] : ["Koch"],
        competitor: quote.competitor,
        legs: [
          {
            // minCars only exists on Rail freight, will be undefined for Truck
            minCars:
              quote.freight && "minCars" in quote.freight
                ? quote.freight.minCars
                : undefined,
          },
        ],
      });
    });
  });

  return routes;
};
